import AbstractView from './AbstractView';

import EmitterManager from 'managers/EmitterManager';
import { REVEALS } from 'core/Events';
// import Canvas from 'components/Canvas';
// import frag from 'shaders/splash.frag';
// import vert from 'shaders/splash.vert';
// import gsap from 'gsap';
import { ENTER /*,  LEAVE */ } from 'core/Classes';
import RAF from 'core/RAF';
import ScrollManager from '../managers/ScrollManager';
import ResizeManager from '../managers/ResizeManager';
import { clamp } from 'gsap/gsap-core';

// const SESSION_KEY = 'home-splash';
// const USE_SESSION = true;

class Home extends AbstractView {
  constructor() {
    super(...arguments);
  }

  initializeBeforeEvents() {
    super.initializeBeforeEvents();
    this.smoothScrollTop = 0;
    // this.header.visible = false;
    // this.isLighthouse = navigator.userAgent.indexOf('Chrome-Lighthouse') > -1;
  }

  bind() {
    super.bind();
    this.handleRaf = this.handleRaf.bind(this);
    // this.destroySplashscreen = this.destroySplashscreen.bind(this);
  }

  // destroySplashscreen() {
  //   const { $home, $splash, $productImage } = this.ui;

  //   this.header.visible = true;

  //   $home.classList.add(ENTER);

  //   EmitterManager.emit(REVEALS, $home);

  //   if ($productImage) {
  //     RAF.suscribe('home', this.handleRaf);
  //   }

  //   if (this.canvas) {
  //     this.canvas.destroy();
  //     delete this.canvas;
  //   }

  //   $splash.remove();
  // }

  handleRaf() {
    const sT = ScrollManager.scrollTop;
    this.smoothScrollTop += (sT - this.smoothScrollTop) * 0.15;

    const progress = clamp(0, 1, this.smoothScrollTop / ResizeManager.height);
    this.ui.$productImage.style.transform = `translateY(${progress * 25}%)`;
  }

  enter() {
    const { $home, $productImage } = this.ui;

    // this.header.visible = true;

    $home.classList.add(ENTER);

    EmitterManager.emit(REVEALS, $home);

    if ($productImage) {
      RAF.suscribe('home', this.handleRaf);
    }

    // const { $splash, $splashLogo } = this.ui;
    // const props = { progress: 0 };

    // if (this.isLighthouse || (USE_SESSION && sessionStorage.getItem(SESSION_KEY))) {
    //   return this.destroySplashscreen();
    // } else {
    //   sessionStorage.setItem(SESSION_KEY, 'seen');
    // }

    // gsap
    //   .timeline({ onComplete: this.destroySplashscreen })
    //   .add(() => $splashLogo.classList.add(ENTER), 0.2)
    //   .to(
    //     props,
    //     {
    //       progress: 1,
    //       duration: 1.5,
    //       ease: 'power3.in',
    //       onComplete: () => {
    //         $splashLogo.classList.add(LEAVE);
    //       },
    //       onUpdate: () => {
    //         this.canvas.parameters.progress = props.progress;
    //       },
    //     },
    //     1
    //   )
    //   .to(
    //     $splash,
    //     {
    //       opacity: 0,
    //       duration: 1,
    //       ease: 'power2.out',
    //       onStart: () => this.ui.$home.classList.add(ENTER),
    //     },
    //     '+=0.8'
    //   );
  }

  // registerComponents() {
  //   super.registerComponents();

  //   if (this.ui.$splashCanvas && (!this.isLighthouse || !USE_SESSION || !sessionStorage.getItem(SESSION_KEY))) {
  //     this.canvas = new Canvas({
  //       $element: this.ui.$splashCanvas,
  //       frag,
  //       vert,
  //     });
  //   }
  // }

  getUI() {
    const ui = super.getUI();
    ui.$home = ui.$element.querySelector('.home');
    ui.$productImage = ui.$element.querySelector('.push-product .image');
    ui.$splash = ui.$element.querySelector('.splashscreen');
    ui.$splashCanvas = ui.$element.querySelector('.splashscreen__canvas');
    ui.$splashLogo = ui.$element.querySelector('.splashscreen__logo');
    return ui;
  }

  handleBreakpoint({ isMobile, isTabletPortrait }) {
    const isLightMode = isMobile || isTabletPortrait;

    // if (isLightMode) {
    // }

    this.isLightMode = isLightMode;
  }
}

export default Home;
